import React from 'react';
import PropTypes from 'prop-types';
import style from './TwoColumnsCustomContentBlock.module.scss';
import { render } from '../render';
import { SmartLink } from '../SmartLink';

const TwoColumnsCustomContentBlock = props => {
    const { content1, content2, backgroundColour, fullWidthBackground, cta } = props;
    console.log(JSON.stringify(cta))
    console.log('cta.text:', cta.text, 'length:', cta.text.length, 'result:', cta.text.length ? 'on' : 'off')

    return (
        <section data-bg={backgroundColour} className={[
            style.el,
            fullWidthBackground ? '' : style.containerWidth,
            backgroundColour === 'white' ? style.white : backgroundColour === 'grey' ? style.grey : backgroundColour === 'blue' ? style.blue : '',
            style[`cta-${cta.text.length ? 'on' : 'off'}`
            ]].join(' ')}>
            <div className={[
                style.contentWrapper,
                fullWidthBackground ? style.restrictWidth : ''
            ].join(' ')}>
                <div className={style.content1}>
                    {content1.map(item => (
                        render(item)
                    ))}
                </div>
                <div className={style.content2}>
                    {content2.map(item => (
                        render(item)
                    ))}
                </div>
            </div>
            { cta.text.length ? <div className={[
                style.cta,
                fullWidthBackground ? '' : style.restrictWidth
            ].join(' ')}>
                <div className={style.ctaWrapper}>
                    <div className={style.ctaLink}>
                        <SmartLink href={cta.link.url} hasArrow className='arrow-link'>
                            {cta.text}
                        </SmartLink>
                    </div>
                </div>
            </div> : null }
        </section>
    );
};

TwoColumnsCustomContentBlock.propTypes = {
    content1: PropTypes.object,
    content2: PropTypes.object,
    cta: PropTypes.object,
    backgroundColour: PropTypes.string,
    fullWidthBackground: PropTypes.bool
};
export default TwoColumnsCustomContentBlock;

TwoColumnsCustomContentBlock.defaultProps = {};
